/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useMemo, useState, useEffect } from 'react';

import { Grid, Typography, makeStyles } from '@material-ui/core';

import CreateCaseModel from '../../models/CreateCaseModel';
import EditFields from '../common/EditFields';
import SimpleTooltip from '../simpleTooltip/SimpleTooltip';

const useStyles = makeStyles(() => {
  return {
    descriptionTypography: {
      color: '#999999',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '24px',
      margin: '8px 0 0',
      textAlign: 'left',
    },
    fieldContainer: {
      paddingTop: '20px',
    },
    fieldEditContainer: {
      marginBottom: '20px',
      marginTop: '4px',
    },
    fieldTitle: {
      color: '#172B4D',
      fontSize: '14px',
      fontWeight: '600',
      lineHeight: '21px',
      marginBottom: '0px',
    },
    onlinePortalContainer: {
      margin: '36px 0px 0px',
    },
  };
});

export default ({ onChangeFormOnlineFolderLink, status, formDescription = true }) => {
  const classes = useStyles();
  const [form, setForm] = useState(status);

  const sharingLinkRef = useRef({});
  const onlineServiceNameRef = useRef({});
  const studyDescriptionRef = useRef({});

  const isFormValid = () => {
    return !!sharingLinkRef.current.getValidData() && !!onlineServiceNameRef.current.getValidData() && !!studyDescriptionRef.current.getValidData();
  };

  const sharingLinkField = useMemo(
    () => [
      {
        autoComplete: 'url',
        containerClass: classes.fieldEditContainer,
        label: '',
        name: 'sharingLink',
        onChange: (value) => {
          onChangeFormOnlineFolderLink(value, 'sharingLink', isFormValid());
        },
        placeholder: 'Example: https://drive.google.com/file/d/1nX...',
        type: 'text',
        variant: 'standard',
      },
    ],
    []
  );

  const onlineServiceNameField = useMemo(
    () => [
      {
        autoComplete: 'on',
        containerClass: classes.fieldEditContainer,
        label: '',
        name: 'onlineServiceName',
        onChange: (value) => {
          onChangeFormOnlineFolderLink(value, 'onlineServiceName', isFormValid());
        },
        placeholder: 'Ex: Google Drive',
        type: 'text',
        variant: 'standard',
      },
    ],
    []
  );

  const studyDescriptionField = useMemo(
    () => [
      {
        autoComplete: 'on',
        containerClass: classes.fieldEditContainer,
        label: '',
        name: 'studyDescription',
        onChange: (value) => {
          onChangeFormOnlineFolderLink(value, 'studyDescription', isFormValid());
        },
        placeholder: 'Example: Head MRI, October 17, 2021',
        type: 'text',
        variant: 'standard',
      },
    ],
    []
  );

  useEffect(() => {
    setForm(status);
  }, [status]);

  return (
    <div className="text-left">
      {/* The code field */}
      <Grid container>
        {formDescription && (
          <Grid item xs={12}>
            <div className={classes.onlinePortalContainer}>
              <Typography className={classes.fieldTitle}>Allowing Access</Typography>

              <Typography className={classes.descriptionTypography}>
                If you have your radiology images on an online folder that you can grant Mediphany access by providing a sharing link so we can access the images and create a video
                report on your behalf.
              </Typography>

              <Typography className={classes.descriptionTypography} style={{ marginTop: '2px' }}>
                If you are not comfortable with this method then please choose one of the other options to allow mediphany to view your images.
              </Typography>
            </div>
          </Grid>
        )}
        <Grid item xs={12} lg={10} xl={8}>
          <Grid container>
            <Grid item xs={12} md={8} className={classes.fieldContainer}>
              <Grid container alignItems="center">
                <Grid item>
                  <Typography className={classes.fieldTitle}>
                    <span style={{ color: '#E92828' }}>*</span> Sharing Link to online Folder
                  </Typography>
                </Grid>

                <Grid item style={{ marginLeft: '8px' }}>
                  <SimpleTooltip
                    wide
                    title="We only need a link that allow us to access the file or folder. If you need to invite us to your folder,
                     you can use this email help@mediphany.com."
                  />
                </Grid>
              </Grid>

              <EditFields
                validate={CreateCaseModel.validateOnlineFolderLink}
                data={form.formOnlineFolderLink}
                labelClass={classes.labels}
                labelPosition="top"
                useAutoFocus={false}
                ref={sharingLinkRef}
                fields={sharingLinkField}
              />
            </Grid>

            <Grid item xs={12} md={8} className={classes.fieldContainer}>
              <Grid container alignItems="center">
                <Grid item>
                  <Typography className={classes.fieldTitle}>
                    <span style={{ color: '#E92828' }}>*</span> Service Name (Google Drive, Dropbox, or other services)
                  </Typography>
                </Grid>
              </Grid>

              <EditFields
                validate={CreateCaseModel.validateOnlineFolderLink}
                data={form.formOnlineFolderLink}
                labelClass={classes.labels}
                labelPosition="top"
                useAutoFocus={false}
                ref={onlineServiceNameRef}
                fields={onlineServiceNameField}
              />
            </Grid>

            <Grid item xs={12} md={8} className={classes.fieldContainer}>
              <div>
                <Typography className={classes.fieldTitle}>
                  <span style={{ color: '#E92828' }}>*</span> Study Description
                </Typography>
              </div>

              <EditFields
                validate={CreateCaseModel.validateOnlineFolderLink}
                data={form.formOnlineFolderLink}
                labelClass={classes.labels}
                labelPosition="top"
                useAutoFocus={false}
                ref={studyDescriptionRef}
                fields={studyDescriptionField}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};
